import React, { useCallback, useState } from 'react';
import { API } from 'aws-amplify';
import { useDropzone } from 'react-dropzone';
import { Card, Dimmer, Header, Loader, Icon, Button, Segment, Grid, Divider } from 'semantic-ui-react';
import UrlAttachmentForm from './UrlAttachmentForm';

async function uploadFile(url = '', file, data) {
  // Encode filename to handle non-ASCII characters (RFC 5987)
  // encodeURIComponent properly handles UTF-8 characters
  const encodedFilename = encodeURIComponent(file.name);

  const response = await fetch(url, {
    method: 'PUT',
    body: data,
    headers: {
      'Content-Type': file.type,
      // Use RFC 5987 encoding for non-ASCII filenames
      'Content-Disposition': `attachment; filename*=UTF-8''${encodedFilename}`
    },
  });
  const responseString = await response.text();
  return responseString;
}

const FileDropzone = ({studentId, reportId, onComplete}) => {
  const [loading, setLoading] = useState(false);
  const [isAddingLink, setIsAddingLink] = useState(false);

  const onDrop = useCallback((acceptedFiles) => {
    setLoading(true);
    acceptedFiles.forEach(async (file) => {
      console.log(file);
      const apiName = 'KnowMyDayAPI';
      const path = '/get-s3-signed-url';

      const attrs = {
        queryStringParameters: {  // OPTIONAL
          studentId,
                                  reportId,
                                  fileName: file.name,
                                  contentType: file.type
        }
      };


      // get the s3 upload url
      const { uploadURL, key } = await API.get(apiName, path, attrs);

      const reader = new FileReader();

      reader.onabort = () => console.log('file reading was aborted')
      reader.onerror = () => console.log('file reading has failed')
      reader.onload = async () => {
        // Do whatever you want with the file contents
        await uploadFile(uploadURL, file, reader.result);
        const blob = new Blob([reader.result]);
        const dataUrl = URL.createObjectURL(blob);
        onComplete({key, name: file.name, contentType: file.type, url: dataUrl});
        setLoading(false);
      }
      reader.readAsArrayBuffer(file)
    })

  }, [studentId, reportId, onComplete]);

  const {getRootProps, getInputProps} = useDropzone({onDrop});

  if (isAddingLink) {
    return (
      <Card>
        <UrlAttachmentForm onSubmit={(file) => { setIsAddingLink(false); onComplete(file);}} onCancel={() => setIsAddingLink(false) } />
      </Card>
    )
  }

  return (
      <Segment placeholder style={{maxWidth: 400}}>
        <Dimmer inverted active={loading}>
          <Loader />
        </Dimmer>
        <Grid columns={2} relaxed='very'>
          <Grid.Column textAlign="center" verticalAlign="middle">
            <Header icon>
              <div  {...getRootProps()}>
                <input {...getInputProps()} />
                <Icon name='attach' />
                <Button>Attach File</Button>
              </div>
            </Header>
          </Grid.Column>

          <Grid.Column textAlign="center" verticalAlign="middle">
            <Header icon>
              <Icon name='linkify' />
              <Button onClick={() => setIsAddingLink(true)}>Add Link</Button>
            </Header>
          </Grid.Column>
        </Grid>
        <Divider vertical>Or</Divider>
      </Segment>
  );
}

export default FileDropzone;
